module.exports = __webpack_public_path__ + "img/fullscreen.f150e31d.svg";